module.exports = __webpack_public_path__ + "img/2025-ford-f-150.265a4a5e.png";